const constants = {
  userDepartment: {
    fabric: 'fabric',
    cutting: 'cutting',
    store: 'store',
    outsourcing: 'outsourcing',
    stitching: 'stitching',
    finishing: 'finishing',
  },
  departmentProcesses: {
    store: {
      inventory: 'inventory',
      checking: 'checking',
    },
    outsourcing: {
      inventory: 'inventory',
      checking: 'checking',
    },
    cutting: {
      precutting: 'precutting',
      recutting: 'recutting',
      finalCutting: 'final cutting',
    },
    washing: {
      preWashing: 'pre washing',
      finalWashing: 'final washing',
    },
    stitching: {
      stitching: 'stitching',
    },
    finishing: {
      finishing: 'finishing',
    },
    packing: {
      packing: 'packing',
    },
    dispatch: {
      dispatch: 'dispatch',
    },
  },
  accessoryRpoProcess: {
    embroidery: 'embroidery',
    handWork: 'Hand Work',
    quilting: 'quilting',
    tasselMaking: 'tassel making',
  },
  rpoProcesses: {
    dyeing: 'dyeing',
    tablePrinting: 'table printing',
    blockPrinting: 'block printing',
    printing: 'printing',
    handEmbroidery: 'hand embroidery',
    computerEmbroidery: 'computer embroidery',
    machineEmbroidery: 'machine embroidery',
    handQuilting: 'hand quilting',
    computerQuilting: 'computer quilting',
    machineQuilting: 'machine quilting',
    maintenanceProcess: 'Maintenance Process',
    washing: 'washing',
    filling: 'filling',
    handWork: 'Hand Work',
  },
  dailyCompletionProcesses: {
    precutting: 'precutting',
    recutting: 'recutting',
    finalCutting: 'final cutting',
    preWashing: 'pre washing',
    finalWashing: 'final washing',
    stitching: 'stitching',
    finishing: 'finishing',
    packing: 'packing',
    dispatch: 'dispatch',
  },
  workerProcesses: {
    katcha: 'Katcha',
    piping: 'Piping',
    tanki: 'Tanki',
    topperMaking: 'Topper Making',
    pallaAttach: 'Palla Attach',
    finalOperation: 'Final Operation',
    labelAttach: 'Label Attach',
    nonOperation: 'Non Operation',
  },
  permissions: {
    createUser: 'createUser',
    updateUser: 'updateUser',
    deleteUser: 'deleteUser',
    recoverUser: 'recoverUser',
    userList: 'userList',
    createRole: 'createRole',
    updateRole: 'updateRole',
    deleteRole: 'deleteRole',
    roleList: 'roleList',
    createCustomer: 'createCustomer',
    updateCustomer: 'updateCustomer',
    deleteCustomer: 'deleteCustomer',
    customerList: 'customerList',
    createVendor: 'createVendor',
    updateVendor: 'updateVendor',
    deleteVendor: 'deleteVendor',
    vendorList: 'vendorList',
    createUnit: 'createUnit',
    updateUnit: 'updateUnit',
    deleteUnit: 'deleteUnit',
    unitList: 'unitList',
    createColor: 'createColor',
    updateColor: 'updateColor',
    deleteColor: 'deleteColor',
    colorList: 'colorList',
    createFactory: 'createFactory',
    updateFactory: 'updateFactory',
    deleteFactory: 'deleteFactory',
    factoryList: 'factoryList',
    createRack: 'createRack',
    updateRack: 'updateRack',
    deleteRack: 'deleteRack',
    rackList: 'rackList',
    createStyle: 'createStyle',
    updateStyle: 'updateStyle',
    deleteStyle: 'deleteStyle',
    styleList: 'styleList',
    createFabric: 'createFabric',
    updateFabric: 'updateFabric',
    deleteFabric: 'deleteFabric',
    fabricList: 'fabricList',
    createAccessory: 'createAccessory',
    updateAccessory: 'updateAccessory',
    deleteAccessory: 'deleteAccessory',
    accessoryList: 'accessoryList',
    createProduct: 'createProduct',
    updateProduct: 'updateProduct',
    deleteProduct: 'deleteProduct',
    productList: 'productList',
    jobchartList: 'jobchartList',
    createJobchart: 'createJobchart',
    updateJobchart: 'updateJobchart',
    deleteJobchart: 'deleteJobchart',
    sampleList: 'sampleList',
    createSample: 'createSample',
    updateSample: 'updateSample',
    deleteSample: 'deleteSample',
    issueSampleItems: 'issueSampleItems',
    timeAction: 'timeAction',
    fabricInventory: 'fabricInventory',
    modifyFabricInventory: 'modifyFabricInventory',
    fabricInventoryTransferAuthorization:
      'fabricInventoryTransferAuthorization',
    fabricInventoryTransferRequestList: 'fabricInventoryTransferRequestList',
    accessoryInventory: 'accessoryInventory',
    modifyAccessoryInventory: 'modifyAccessoryInventory',
    accessoryInventoryTransferAuthorization:
      'accessoryInventoryTransferAuthorization',
    accessoryInventoryTransferRequestList:
      'accessoryInventoryTransferRequestList',
    issueReceive: 'issueReceive',
    issueReceiveList: 'issueReceiveList',
    viewChallan: 'viewChallan',
    createRenukaPO: 'createRenukaPO',
    updateRenukaPO: 'updateRenukaPO',
    deleteRenukaPO: 'deleteRenukaPO',
    renukaPOList: 'renukaPOList',
    itemTableInrenukaPO: 'itemTableInrenukaPO',
    createStoreInward: 'createStoreInward',
    updateStoreInward: 'updateStoreInward',
    deleteStoreInward: 'deleteStoreInward',
    storeInwardList: 'storeInwardList',
    createStoreOutward: 'createStoreOutward',
    updateStoreOutward: 'updateStoreOutward',
    deleteStoreOutward: 'deleteStoreOutward',
    storeOutwardList: 'storeOutwardList',
    createQualityCheck: 'createQualityCheck',
    updateQualityCheck: 'updateQualityCheck',
    deleteQualityCheck: 'deleteQualityCheck',
    qualityCheckList: 'qualityCheckList',
    MRR: 'MRR',
    outwardReport: 'outwardReport',
    weeklyPlan: 'weeklyPlan',
    dailyCompletionForm: 'dailyCompletionForm',
    dailyCompletionList: 'dailyCompletionList',
    createCostSheet: 'createCostSheet',
    updateCostSheet: 'updateCostSheet',
    deleteCostSheet: 'deleteCostSheet',
    costSheetList: 'costSheetList',
    userTimeAndActionTracking: 'userTimeAndActionTracking',
    createWorker: 'createWorker',
    updateWorker: 'updateWorker',
    deleteWorker: 'deleteWorker',
    recoverWorker: 'recoverWorker',
    workerList: 'workerList',
    addWorkerJob: 'addWorkerJob',
    deleteWorkerJob: 'deleteWorkerJob',
    workerJobList: 'workerJobList',
    approveWorkerJob: 'approveWorkerJob',
    addWorkerIssue: 'addWorkerIssue',
    deleteWorkerIssue: 'deleteWorkerIssue',
    workerIssueList: 'workerIssueList',
    approveWorkerIssue: 'approveWorkerIssue',
  },
};

export default constants;

export const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'The Democratic Republic of Congo',
  'Cook Islands',
  'Costa Rica',
  'Ivory Coast',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'England',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji Islands',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Isle of Man',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'North Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'North Korea',
  'Northern Ireland',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Scotland',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wales',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const states = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Dadra and Nagar Haveli and Daman and Diu',
];
